import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { formatPlaceholder } from '../../lib/utils';
import CustomInputField from '../../ui/primitives/CustomInputField';
import ActionButton from '../../ui/primitives/ActionButton';

const AutomationDetailsForm = ({
  data,
  handleChange,
  handleSave,
  showAuthToken,
  setShowAuthToken,
  error,
  labels,
  submitting,
  readOnly,
}) => {
  const handleFieldChange = (id, value) => {
    handleChange({ target: { id, value } });
  };

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          {readOnly ? (
            <Box>
              <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>
                {labels.urlLabel}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {data[labels.urlPlaceholder] || formatPlaceholder()}
              </Typography>
            </Box>
          ) : (
            <CustomInputField
              id={labels.urlPlaceholder}
              label={labels.urlLabel}
              required
              placeholder={`Enter ${labels.urlLabel}`}
              value={data[labels.urlPlaceholder]}
              onChange={handleFieldChange}
            />
          )}
        </Grid>

        <Grid item xs={12} md={4}>
          {readOnly ? (
            <Box>
              <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>
                {labels.usernameLabel}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {data[labels.usernamePlaceholder] || formatPlaceholder()}
              </Typography>
            </Box>
          ) : (
            <CustomInputField
              id={labels.usernamePlaceholder}
              label={labels.usernameLabel}
              required
              placeholder={`Enter ${labels.usernameLabel}`}
              value={data[labels.usernamePlaceholder]}
              onChange={handleFieldChange}
            />
          )}
        </Grid>

        {!readOnly && (
          <Grid item xs={12} md={4}>
            <CustomInputField
              id={labels.tokenPlaceholder}
              label={labels.tokenLabel}
              required
              placeholder={`Enter ${labels.tokenLabel}`}
              value={data[labels.tokenPlaceholder]}
              onChange={handleFieldChange}
              type={showAuthToken ? 'text' : 'password'}
            />
            <Box
              component="label"
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.75,
                mt: 0.75,
                cursor: 'pointer',
              }}
            >
              <input
                type="checkbox"
                checked={showAuthToken}
                onChange={() => setShowAuthToken(!showAuthToken)}
              />
              <Typography variant="caption" color="text.secondary">
                Show Token
              </Typography>
            </Box>
          </Grid>
        )}
      </Grid>

      {error && (
        <Typography variant="caption" color="error.main" sx={{ mt: 1, display: 'block' }}>
          * {error}
        </Typography>
      )}

      {!readOnly && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
          <ActionButton
            label={submitting ? 'Saving…' : 'Save Details'}
            intent="primary"
            onClick={handleSave}
            loading={submitting}
            disabled={submitting}
          />
        </Box>
      )}
    </Box>
  );
};

export default AutomationDetailsForm;